module.exports = __webpack_public_path__ + "img/skills_illustrator.45d1ed21.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/skills_illustrator.svg
// module id = pcn/
// module chunks = 1